<template>
    <div id="ad-map-cnt">
        <button @click="toggleMap" v-if="!show_map" class="btn btn-custom w-lg m-b-15"><i class="far fa-map m-r-5"></i> Mostrar Mapa</button>
        <button @click="toggleMap" v-if="show_map" class="btn btn-custom w-lg m-b-15"><i class="far fa-map m-r-5"></i> Esconder Mapa</button>
        <div v-show="map_visible" v-bind:style="mapStyle" id="ad_map"></div>
    </div>
</template>

<script>
export default {
    props: {
        lat: {
            type: Number,
            required: true
        },
        lng: {
            type: Number,
            required: true,
        },
        zoom: {
            type: Number,
            required: false,
            default: 14
        },
        height: {
            type: Number,
            required: false,
            default: 620
        }
    },
    data: () => {
        return {
            show_map: 0,
            loaded_map: 0,
            map_visible: 1,
        };
    },
    computed: {
        mapStyle: function () {
            if (this.map_visible && this.loaded_map) {
                return {
                    height: this.height + 'px'
                };
            } else {
                return {};
            }
        }
    },
    methods: {
        toggleMap: function () {
            this.show_map = !this.show_map;
            if (this.show_map == 1) {
                if (!this.loaded_map) {
                    this.renderMap();
                }
                this.map_visible = 1;
                this.loaded_map = 1;
            } else {
                this.map_visible = 0;
            }
        },
        renderMap: function() {
            mapboxgl.accessToken = 'pk.eyJ1IjoiZHllZ29uZXJ5IiwiYSI6ImNqdzgzMWpiMjJsN3Q0MG1tODE1YThjdXYifQ.edguOQs5PzWymNRTBXScNw';
            var map = new mapboxgl.Map({
                container: 'ad_map',
                style: 'mapbox://styles/mapbox/streets-v12',
                center: new mapboxgl.LngLat(parseFloat(this.lng), parseFloat(this.lat)),
                zoom: this.zoom,
            });

            map.addControl(new mapboxgl.NavigationControl(), 'bottom-right');
            map.on('load', () => {
                map.resize();

                map.addLayer({
                    "id": "ad_ci",
                    "type": "circle",
                    "source": {
                        "type": "geojson",
                        "data": {
                            "type": "FeatureCollection",
                            "features": [{
                                "type": "Feature",
                                "geometry": {
                                    "type": "Point",
                                    "coordinates": [parseFloat(this.lng), parseFloat(this.lat)]
                                }
                            }]
                        }
                    },
                    "paint": {
                        'circle-color': '#666',
                        'circle-radius': 150,
                        'circle-stroke-width': 1,
                        'circle-stroke-color': '#666',
                        'circle-opacity': 0.5
                    },
                });
            });
        }
    },
    mounted: function() {
    }
}
</script>

<style lang="scss">
    // @import "mapbox-gl/dist/mapbox-gl.css";
    #ad-map-cnt {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    #ad_map {
        width: 100%;

        canvas {
            left: 0;
        }
    }
</style>

